/**
 * @generated SignedSource<<53e36a3c1d1046444591d6632be5d7a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecentActivityPreview_activity$data = {
  readonly __typename: "MessageActivity";
  readonly id: string;
  readonly createdAt: string;
  readonly body: string;
  readonly authorType: string;
  readonly direction: string | null;
  readonly author: {
    readonly fullName: string | null;
  } | null;
  readonly " $fragmentType": "RecentActivityPreview_activity";
} | {
  readonly __typename: "InternalCommentActivity";
  readonly id: string;
  readonly createdAt: string;
  readonly body: string;
  readonly author: {
    readonly fullName: string | null;
  } | null;
  readonly mentionedUsers: ReadonlyArray<{
    readonly id: string;
    readonly fullName: string | null;
  }>;
  readonly " $fragmentType": "RecentActivityPreview_activity";
} | {
  readonly __typename: "EventActivity";
  readonly id: string;
  readonly createdAt: string;
  readonly eventType: string;
  readonly actor: {
    readonly fullName: string | null;
  } | null;
  readonly oldValue: string | null;
  readonly newValue: string | null;
  readonly " $fragmentType": "RecentActivityPreview_activity";
} | {
  readonly __typename: "AttachmentActivity";
  readonly id: string;
  readonly createdAt: string;
  readonly filename: string;
  readonly " $fragmentType": "RecentActivityPreview_activity";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "RecentActivityPreview_activity";
};
export type RecentActivityPreview_activity$key = {
  readonly " $data"?: RecentActivityPreview_activity$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecentActivityPreview_activity">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecentActivityPreview_activity",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "authorType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "direction",
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "type": "MessageActivity",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "mentionedUsers",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "InternalCommentActivity",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "actor",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oldValue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newValue",
          "storageKey": null
        }
      ],
      "type": "EventActivity",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filename",
          "storageKey": null
        }
      ],
      "type": "AttachmentActivity",
      "abstractKey": null
    }
  ],
  "type": "ActivityEvent",
  "abstractKey": "__isActivityEvent"
};
})();

(node as any).hash = "1f3d433ec6e84f7f0bcb6b0377b231f9";

export default node;
